import React from 'react';

import {Redirect, Route, Router, Switch} from 'react-router-dom';
import {createBrowserHistory} from 'history';

import Header from './components/stateless/Header';
import Footer from './components/stateless/Footer';

import Home from './pages/Home';
import Solutions from './pages/Solutions';
import Services from './pages/Services';
import ItemSinglePage from './pages/ItemSinglePage';
import BecomePartner from './pages/BecomePartner';
import RequestDemo from './pages/RequestDemo';
import ProductsBlog from './pages/ProductsBlog';
import ProductsBlogCategory from './pages/ProductsBlogCategory';
import ProductsBlogSingleItem from './pages/ProductsBlogSingleItem';
import NotFound from './pages/NotFound';
import useMount from './hooks/useMount';
import About from './pages/About';
import KnowledgeBase from './pages/KnowledgeBase';
import MarketPlace from './pages/Marketplace';
import MarketplaceSinglePage from './pages/MarketplaceSinglePage';

import './App.scss';

const {REACT_APP_INTERCOM_KEY} = process.env;

const history = createBrowserHistory();

function App() {
    useMount(() => {
        if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_CUSTOM_NODE_ENV === 'production' && window.Intercom) {
            window.Intercom('boot', {
                app_id: REACT_APP_INTERCOM_KEY,
                name: null,
                email: null
            });
        }
    });

    return (
        <Router history={history}>
            <Header />
            <Switch>
                <Redirect exact from="/" to={'/home'}/>
                <Route path={'/home'} component={Home}/>
                <Route path={'/solutions'} render={(props) => <Solutions {...props} />}/>
                <Route path={'/services'} render={(props) => <Services {...props} />} />
                <Route path={'/become-partner'} component={BecomePartner}/>
                <Route path={'/request-demo'} component={RequestDemo}/>
                <Route path={'/not-found'} component={NotFound}/>
                <Route path={'/products-blog/:category/:singleItem'}
                       component={(props) => <ProductsBlogSingleItem {...props} />}/>
                <Route path={'/products-blog/:category'} component={(props) => <ProductsBlogCategory {...props} />}/>
                <Route path={'/products-blog'} component={ProductsBlog}/>
                <Route path={'/about'} component={About}/>
                <Route path={'/knowledge-base'} render={(props) => <KnowledgeBase {...props} />} />
                <Route path={'/marketplace/:templateId'} component={(props) => <MarketplaceSinglePage {...props} />}/>
                <Route path={'/marketplace'} component={MarketPlace} />
                {/*
                 <Route path={'/partnership'} component={Partnership} />
                 */}
                <Route path={'/:category/:categoryItem'} render={(props) => <ItemSinglePage {...props} />}/>
                <Redirect to='/not-found' />
            </Switch>
            <Footer />
        </Router>
    );
}

export default App;
